export const ROUTINE_LIST_QUERY_KEY = 'routine-list';
export const WORKOUT_LIST_QUERY_KEY = 'workout-list';
export const WORKOUT_COUNT_QUERY_KEY = 'workout-count';
export const WORKOUT_QUERY_KEY = 'workout';
export const SEARCH_ROUTINE_QUERY_KEY = 'search';
